import React from "react";
import styles from "./your-gender.module.css";
import { Page } from "../../components/page/page";
import { ReactComponent as ImageMale } from "../../../../images/male.svg";
import { ReactComponent as ImageFemale } from "../../../../images/female.svg";
import { ReactComponent as ImageOther } from "../../../../images/other.svg";
import { Link } from "react-router-dom";
import { setGender } from "../../store/stateSlice";
import { useDispatch } from "react-redux";


const YourGenderPage = () => {
  const dispatch = useDispatch();
  
  return (
    <Page title="What is your gender?" currentStep={5} hideContinueButton={true}>
      <div className={styles.container_gender}>
        <div className={styles.image_male} onClick={() => dispatch(setGender("male"))}>
          <Link to={"../your-zodiac"}>
            <div className={styles.image_gender}>
              <ImageMale />
              <p className={styles.gender_text}>male</p>
            </div>
          </Link>
        </div>
        <div className={styles.image_female} onClick={() => dispatch(setGender("female"))}>
          <Link to={"../your-zodiac"}>
            <div className={styles.image_gender}>
              <ImageFemale />
              <p className={styles.gender_text}>female</p>
            </div>
          </Link>
        </div>
        <div className={styles.image_other} onClick={() => dispatch(setGender("other"))}>
          <Link to={"../your-zodiac"}>
            <div className={styles.image_gender}>
              <ImageOther />
              <p className={styles.gender_text}>other</p>
            </div>
          </Link>
        </div>
      </div>
    </Page>
  );
};

export { YourGenderPage };
